module.exports = __webpack_public_path__ + "static/img/digitalize.63d395d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/unifiedProcessPhone/digitalize.png
// module id = Mf+H
// module chunks = 0